import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AssessmentTitle } from 'src/components/AssessmentTitle';
import { useChartData } from '../../../stores/appointment/appointment.store';

export const AssessmentContainer: FC = () => {
  const { chartData } = useChartData();
  const { t } = useTranslation();

  const diagnoses = chartData?.diagnosis;
  const primaryDiagnosis = diagnoses?.find((item) => item.isPrimary);
  const otherDiagnoses = diagnoses?.filter((item) => !item.isPrimary);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, width: '100%' }}>
      <Typography variant="h5" color="primary.dark">
        {t('telemed.review.assessment.title')}
      </Typography>
      <>
        {primaryDiagnosis && (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
            <AssessmentTitle>{t('telemed.review.assessment.primary')}</AssessmentTitle>
            <Typography>
              {primaryDiagnosis.display} {primaryDiagnosis.code}
            </Typography>
          </Box>
        )}
        {otherDiagnoses && otherDiagnoses.length > 0 && (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
            <AssessmentTitle>{t('telemed.review.assessment.secondary')}</AssessmentTitle>
            {otherDiagnoses.map((diagnosis) => (
              <Typography key={diagnosis.resourceId}>
                {diagnosis.display} {diagnosis.code}
              </Typography>
            ))}
          </Box>
        )}
      </>
    </Box>
  );
};
